import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Table from "../../components/Table";
import { LogsMonitoringColumns } from "../../components/headerContent";
import NumberCard from "../../components/Card/NumberCard";
import CarousselNav from "../../components/Card/CarousselNav";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons"; 
import Loader from "../../components/Loader";
import { useTranslation } from "react-i18next";

export default function Logs() {
    const { apiUrl } = useContext(AuthContext);
    const [flattenedLogs, setFlattenedLogs] = useState([]);
    const valuesType = ["Tous", "Elit-Technologies", "Autres"];
    const [currentSlide, setCurrentSlide] = useState(0);
    const { t } = useTranslation();

    const getLogs = async () => {
        try {
            const res = await axios.get(`${apiUrl}log/index`, {
                withCredentials: true,
            });
            return res.data;
        } catch (error) {
            console.error("Failed to fetch logs:", error);
            return { logs: [] };
        }
    };

    const logs = useQuery({
        queryKey: ["logs"],
        queryFn: getLogs,
    });

    // Filter logs based on the current slide
    useEffect(() => {
        if (logs.data?.logs) {
            let logsFiltered;

            switch (valuesType[currentSlide]) {
                case "Elit-Technologies":
                    logsFiltered = logs.data.logs.filter((log) => {
                        const email = log.extra?.userData?.email;
                        return email && email.endsWith("@elit-technologies.fr");
                    });
                    break;

                case "Autres":
                    logsFiltered = logs.data.logs.filter((log) => {
                        const email = log.extra?.userData?.email;
                        return !email || !email.endsWith("@elit-technologies.fr");
                    });
                    break;

                default:
                    logsFiltered = logs.data.logs;
                    break;
            }

            const newFlattenedData = logsFiltered.map((log) => {
                const { message, ...rest } = log;
                return {
                    ...rest,
                    log: message,
                };
            });

            setFlattenedLogs(newFlattenedData);
        }
    }, [logs.data?.logs, currentSlide]);

    if (!logs.isLoading && (!logs.data?.logs || logs.data.logs.length === 0)) {
        return (
            <div className="ecp-container">
                <div className="ecp-container-content-error">
                    <div className="error-container">
                        <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
                        <div className="error-container-text">
                            <h1 className="page-title">
                                {t("Aucune donnée disponible")}
                            </h1>
                            <p className="page-link_home">
                                <Link to="/"> {t("Revenir à l'accueil")}</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="ecp-container">
            <div className="ecp-container-content">
                {!logs.isLoading ? (
                    <>
                        <div className="ecp-container-content-header">
                            <div className="ecp-container-content-header-title">
                                <div className="page-title page-logo">
                                    <h1 className="page-title">Logs</h1>
                                </div>
                                <CarousselNav
                                    arrayValues={valuesType}
                                    currentSlide={currentSlide}
                                    setCurrentSlide={setCurrentSlide}
                                />
                            </div>
                        </div>
                        {flattenedLogs?.length > 0 && (
                            <section className="page-section">
                                          <NumberCard
                                            title={`${t("Logs disponibles")}`}
                                            number={
                                              flattenedLogs.length
                                            }
                                            logo={faCircleCheck}
                                            color={"#AEC353"}
                                            stylesIcons={"logo-certificats"}
                                          />
                                        </section>
                        )}
                        {flattenedLogs?.length > 0 && (
                            <Table
                                tableData={flattenedLogs}
                                tableColumns={LogsMonitoringColumns}
                            />
                        )}
                    </>
                ) : (
                    <Loader />
                )}
            </div>
        </div>
    );
}